import { TmApiClientError } from '@/core/error/transport/tmApiClientError'

export class TmApiPaymentRequiredError extends TmApiClientError {
  public name = 'TmApiPaymentRequiredError'
}
